// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"7efa3324","540":"2e3d468f"}[chunkId] + ".chunk.js";
};